import { Trans } from "react-i18next";
import { partners } from "../../../constants/partners";
import { CmsPartner } from "../../../types/cms.types";

type PartnersSectionProps = {
    styles: Record<string, string>;
    showTitles?: boolean;
    cmsPartners?: CmsPartner[]; // Optional CMS partners; built-in list is the fallback
};

const PartnersSection = ({ styles, showTitles = false, cmsPartners }: PartnersSectionProps) => {
    // CMS partners replace the built-in list once at least one is published
    const validCmsPartners = cmsPartners?.filter((partner) => partner.logoUrl) ?? [];
    const items = validCmsPartners.length
        ? validCmsPartners.map((partner) => ({
              key: partner._id,
              title: partner.title ?? "",
              logo: partner.logoUrl,
              url: partner.url,
          }))
        : partners.map((partner, index) => ({
              key: `${partner.slug}-${index}`,
              title: partner.title,
              logo: partner.logo as string | undefined,
              url: undefined as string | undefined,
          }));

    return (
        <div className={styles.PartnerSection}>
            <p className={styles.PartnerSectionTitle}>
                <Trans i18nKey="home.partners.title" components={{ 1: <span /> }} />
            </p>
            <div className={styles.Partners}>
                {items.map((partner) => {
                    const content = (
                        <>
                            <img src={partner.logo} alt={partner.title} />
                            {showTitles && <p className={styles.PartnerTitle}>{partner.title}</p>}
                        </>
                    );
                    return partner.url ? (
                        <a
                            className={styles.Partner}
                            key={partner.key}
                            href={partner.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {content}
                        </a>
                    ) : (
                        <div className={styles.Partner} key={partner.key}>
                            {content}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PartnersSection;
